import React, { useEffect, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
  useMap,
} from "react-leaflet";
import "leaflet.heat";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

const JamaicaCenter = [18.1096, -77.2975];


const MapUpdater = ({ lat, lng }) => {
  const map = useMap();

  useEffect(() => {
    if (lat && lng) {
      const timer = setTimeout(() => {
        map.invalidateSize();
        map.setView([parseFloat(lat), parseFloat(lng)], 15);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [lat, lng, map]);

  return null;
};

L.Marker.prototype.options.icon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default function MapContainerComponent({ latitude, longitude, vehicle_name }) {

  return (
    <div style={{ height: "400px", width: "100%" }}>
      <MapContainer
        center={[latitude ?? 18.1096, longitude ?? -77.2975]}
        zoom={6}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <MapUpdater lat={latitude} lng={longitude} />
        {latitude && longitude && (
          <Marker position={[latitude, longitude]}>
            <Popup>
              <strong>{vehicle_name}</strong>
            </Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
}
